import styles from './Question.module.scss';
import { Container, Heading, Content } from '@wienenergiegithub/ui-next';
import React from 'react';
import PropTypes from 'prop-types';

const Question = ({ subtitle = null, title }) => (
  <Container>
    <Heading as="h3" noSpacing size="h2">
      {title}
    </Heading>
    {!!subtitle && (
      <Content className={styles.subtitle} noSpacing>
        {subtitle}
      </Content>
    )}
  </Container>
);

Question.propTypes = {
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export { Question };
